import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import API_CONFIG from '../config/api';
import { useTranslation } from '../i18n/LocaleContext';

const CAPTCHA_URL = `${API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.AUTH)}/captcha`;

// 图形验证码输入框:图片由后端生成、一次性。
// 首次拉取失败自动重试一次;仍失败显示"点击重试",点击按钮重新拉取。
// onChange(code, captchaId) 上报表单;提交失败后父组件自增 refreshSignal 即重取新图。
const ImageCaptchaField = ({ refreshSignal = 0, onChange, dark = false }) => {
  const { t } = useTranslation();
  const [svg, setSvg] = useState('');
  const [code, setCode] = useState('');
  const [failed, setFailed] = useState(false);
  const idRef = useRef('');
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const load = async (isRetry = false) => {
    try {
      const { data } = await axios.get(CAPTCHA_URL);
      idRef.current = data.captchaId;
      setSvg(data.svg);
      setFailed(false);
    } catch (e) {
      idRef.current = '';
      setSvg('');
      setFailed(isRetry);
      if (!isRetry) {
        setTimeout(() => load(true), 1000);
      }
    }
    setCode('');
    onChangeRef.current('', idRef.current);
  };

  useEffect(() => {
    load();
    // refreshSignal 变化时重取(挂载即取一次)
  }, [refreshSignal]);

  const inputCls = dark
    ? 'flex-1 h-[52px] rounded-lg bg-gray-800 border border-gray-700 px-3.5 text-[15px] text-white placeholder-gray-500 outline-none focus:border-yellow-400 transition-colors'
    : 'flex-1 h-[50px] rounded-full bg-white border border-gray-200 px-4 text-[15px] text-ink placeholder-ink-muted/80 outline-none focus:border-brand-500 transition-colors';

  return (
    <div className="flex items-center gap-2.5">
      <input
        type="text"
        inputMode="latin"
        autoComplete="off"
        maxLength={6}
        value={code}
        onChange={(e) => {
          setCode(e.target.value);
          onChangeRef.current(e.target.value, idRef.current);
        }}
        placeholder={t('enterImageCaptcha')}
        className={inputCls}
      />
      <button
        type="button"
        onClick={() => load()}
        aria-label={t('enterImageCaptcha')}
        className={`w-[110px] h-[50px] flex-shrink-0 overflow-hidden flex items-center justify-center ${dark ? 'rounded-lg bg-gray-800 border border-gray-700' : 'rounded-full bg-white border border-gray-200'}`}
      >
        {svg ? (
          <img
            src={`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`}
            alt=""
            className="h-full w-auto"
            draggable={false}
          />
        ) : (
          <span className={`text-[11px] px-1 text-center ${failed ? 'text-red-400' : 'text-ink-muted'}`}>{failed ? t('captchaRetry') : t('processing')}</span>
        )}
      </button>
    </div>
  );
};

export default ImageCaptchaField;
